const stacksList = [
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/javascript/javascript-original.svg',
        name: 'JavaScript'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/css3/css3-original.svg',
        name: 'CSS3'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/html5/html5-original.svg',
        name: 'HTML5'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/react/react-original.svg',
        name: 'React'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/vuejs/vuejs-original.svg',
        name: 'Vue.js'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/typescript/typescript-original.svg',
        name: 'TypeScript'
    },
    {
        icon: 'https://devicon.dev/devicon.git/icons/nodejs/nodejs-original.svg',
        name: 'Node.js'
    },
    
    {
        icon: 'https://devicon.dev/devicon.git/icons/express/express-original.svg',
        name: 'Express'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/git/git-original.svg',
        name: 'Git'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/github/github-original.svg',
        name: 'GitHub'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/illustrator/illustrator-plain.svg',
        name: 'Illustrator'
    },
    {
        icon: 'https://devicons.github.io/devicon/devicon.git/icons/photoshop/photoshop-plain.svg',
        name: 'Photoshop'
    },
]

export default stacksList;